// extracted by mini-css-extract-plugin
module.exports = {"artistLink":"styles_artistLink__3wCqL","artistName":"styles_artistName__3Lwoh"};